import { getEnv } from '@luna/env';
import { isLocalEnvironment } from '@shared/environment';

export function getRetailLocalesBasePath(): string {
    const isLocalEnv = isLocalEnvironment();
    const { webTranslationsUrl, version: configVersion } = getEnv();

    if (webTranslationsUrl) {
        return webTranslationsUrl;
    }

    if (isLocalEnv) {
        return '/locales/';
    }

    return `/prod/locales_${configVersion}/`;
}
